import { useState } from 'react'
import styles from './ProseCard.module.css'

interface ProseCardProps {
    heading: string
    body: readonly string[]
}

/**
 * A prose card that collapses to a teaser on narrow screens.
 *
 * The full text is always rendered -- it is only clamped by CSS -- so it stays
 * in the DOM for search engines and for anyone who finds the page with a
 * text-only browser. Above the breakpoint the clamp and the control both
 * disappear and the card is simply a card.
 */
export default function ProseCard({ heading, body }: ProseCardProps) {
    const [expanded, setExpanded] = useState(false)

    return (
        <article className={styles.card}>
            <h3 className={styles.heading}>{heading}</h3>
            <div className={expanded ? styles.bodyOpen : styles.body}>
                {body.map((p) => <p key={p} className={styles.para}>{p}</p>)}
            </div>
            <button
                type="button"
                className={styles.more}
                aria-expanded={expanded}
                onClick={() => setExpanded((v) => !v)}
            >
                {expanded ? 'Show less' : 'Read more'}
            </button>
        </article>
    )
}
